import _ from 'underscore';
import angular from 'angular';

import config from 'src/config';

urlService.$inject = [];

const production = config.NODE_ENV === 'production';

export default function urlService() {
  class UrlService {
    venuePartnerLink(venueSlug) { //eslint-disable-line
      const base = production ? 'partner' : 'partner-dev';
      const url = `https://${base}.tablelist.com/register-venue/`;

      return `${url}${venueSlug}/step_one`;
    }

    eventLink(eventId) { //eslint-disable-line
      const base = production ? 'www' : 'www-dev';
      const url = `https://${base}.tablelist.com`;

      return `${url}/event/${eventId}`;
    }

    venueLink(venueSlug) { //eslint-disable-line
      const base = production ? 'www' : 'www-dev';
      const url = `https://${base}.tablelist.com/venues/`;

      return url + venueSlug;
    }

    bookLink(venueSlug) { //eslint-disable-line
      const base = production ? 'www' : 'www-dev';
      const url = `https://${base}.tablelist.com/book/`;

      return url + venueSlug;
    }

    addQueryParams(url, params) { //eslint-disable-line
      if (!url) return '';
      if (!params) return url;

      params = _.pickBy(params, function(value) {
        return value !== null && value !== undefined;
      });

      url += `?${angular.element.param(params)}`;

      return url;
    }
  }

  return new UrlService();
}



// WEBPACK FOOTER //
// ./src/services/urlService.js